import React, { useEffect, useState } from "react";
import { IoPaperPlane } from "react-icons/io5";
import { toast } from "react-hot-toast";

import MultipleSelectInput from "../../../../../components/MultipleSelectInput";
import TextEditor from "../../../../../components/TextEditor";
import Modal from "../../../../../components/modal";
import api from "../../../../../services/api";
import Secretaire from "../../../../../assets/secretaire.gif";

const cc_emails = ["admin@selego.co", "office@selego.co"];

export default ({ notions, selectedNotions, setSelectedNotions, project }) => {
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [recipients, setRecipients] = useState([]);

  const [config, setConfig] = useState({
    language: "french",
    tone: "formal",
  });

  const [users, setUsers] = useState([]);

  async function getUsers() {
    try {
      const { ok, data } = await api.post(`/user/search`, { project_ids: [project._id], status: "active" });
      if (!ok) throw new Error(data.error);
      setUsers(data.users);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    setSelectedNotions(notions);
  }, [notions]);

  const [mail, setMail] = useState({
    subject: "Rapport hebdomadaire d'avancement",
    body: "",
  });

  async function load() {
    try {
      if (!selectedNotions.length) return toast.error("No tickets selected");
      setLoading(true);
      setRecipients(users.map((u) => u.email));
      const { data: body } = await api.post(`/project/report/${project._id}`, { tickets: selectedNotions, ...config });
      setMail({ ...mail, body });
    } catch (error) {
      console.error(error);
      toast.error("Error generating report");
    } finally {
      setLoading(false);
    }
  }

  async function sendEmail() {
    try {
      if (!recipients.length) return toast.error("Please add recipients");
      setSending(true);
      await api.post(`/project/${project._id}/send-report`, { recipients, ...mail });
      toast.success("Email sent !");
      setMail({
        subject: "",
        body: "",
        cc: cc_emails,
      });
      setRecipients([]);
    } catch (error) {
      console.error(error);
      toast.error("Error sending email");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="grid grid-cols-12 gap-2">
      <div className="col-span-12 text-center text-sm text-gray-600 bg-orange-100 text-orange-700 p-2 rounded-lg">WORK IN PROGRESS</div>
      <div className="col-span-12 p-4 bg-white rounded-lg border border-gray-200">
        <div className="flex flex-col gap-2 mb-4">
          <div className="text-sm text-gray-600">Report Configuration</div>
          <div className="grid grid-cols-12 gap-2">
            <select className="input col-span-3" value={config.tone || ""} onChange={(e) => setConfig({ ...config, tone: e.target.value })}>
              <option value="">Default Tone</option>
              <option value="formal">Formal</option>
              <option value="casual">Casual</option>
              <option value="technical">Technical</option>
            </select>
            <select className="input col-span-3" value={config.language || ""} onChange={(e) => setConfig({ ...config, language: e.target.value })}>
              <option value="">Default Language</option>
              <option value="english">English</option>
              <option value="french">French</option>
            </select>
            <button className="btn gray-btn disabled:opacity-50 col-span-3" onClick={load} disabled={loading}>
              Generate report
            </button>
            <button disabled={loading || !mail.body || !recipients.length || sending} className="btn blue-btn disabled:opacity-50 col-span-3" onClick={sendEmail}>
              <IoPaperPlane />
              Send
            </button>
          </div>
          <div className="text-xs text-gray-500 italic">
            Tip: You can filter tickets by status, priority or size to include specific items in your report. The report will be generated based on your selection.
          </div>
        </div>
        <div className="flex items-center gap-2 mb-4">
          <span className="text-base text-gray-700">
            Using <strong className="font-bold">{selectedNotions.length}</strong> tickets
          </span>
        </div>
      </div>

      <div className="col-span-12">
        {loading ? (
          <div className="flex flex-col items-center justify-center p-8 gap-3">
            <img src={Secretaire} alt="Loading animation" className="h-32 object-contain" />
            <div className="text-sm text-gray-600 italic">Generating report from {selectedNotions.length} tickets...</div>
          </div>
        ) : (
          <div className="flex flex-col gap-2 p-3 pt-5 w-full">
            <MultipleSelectInput value={recipients} label="To" placeholder="Add recipients..." onChange={(e) => setRecipients(e)} />
            <div className="w-full">
              <div className="px-1 text-sm text-gray-600 font-medium">Subject</div>
              <input
                disabled={loading}
                className="w-full rounded-md border-[1px] bg-white disabled:bg-gray-100 border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 md:text-sm placeholder:text-gray-300 py-2 px-2"
                name="subject"
                value={mail.subject}
                onChange={(e) => setMail({ ...mail, subject: e.target.value })}
              />
            </div>
            <div className="mt-3">
              <div className="px-1 text-sm text-gray-600 font-medium">Message</div>
              <TextEditor
                value={mail.body}
                onChange={(e) => setMail({ ...mail, body: e.target.value })}
                defaultPrompt={`Help me format this email properly for giving project progress detail to client. The email: ${mail.body}`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
